import React, { useEffect, useCallback, useState } from 'react';
import InputTextQuestion from './InputTextQuestion';
import { Link } from 'react-router-dom';
import { isValidEmail } from 'helpers/validation';
import { debounce } from 'throttle-debounce';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from 'redux/actions';
import classNames from 'classnames';

function EmailCheckInputQuestion(props) {
  // const [emailExists, setEmailExists] = useState(false);

  const debounceSearchUser = useCallback(
    debounce(500, (email) => {
      props.onChange(undefined, props.question.emailExistsVariable);

      props.actions.checkEmail({ email }).then(
        () => {
          // setEmailExists(false);
          props.onChange(false, props.question.emailExistsVariable);
        },
        () => {
          // setEmailExists(true);
          props.onChange(true, props.question.emailExistsVariable);
        },
      );
    }),
    [],
  );

  useEffect(() => {
    if (
      !props.user.authenticated &&
      isValidEmail(props.model[props.question.variable])
    ) {
      debounceSearchUser(props.model[props.question.variable]);
    }
  }, [props.model[props.question.variable]]);

  useEffect(() => {
    if (props.user.authenticated) {
      props.onChange(props.user.user.email, props.question.variable);
    }
  }, []);

  const containerClassName = classNames('email-check-input-question question', {
    'is-invalid':
      (props.model[props.question.variable] &&
        !isValidEmail(props.model[props.question.variable])) ||
      props.model[props.question.emailExistsVariable],
  });

  return (
    <div className={containerClassName}>
      <InputTextQuestion {...props} />
      {props.model[props.question.emailExistsVariable] === true ? (
        <p className="av-black mt-3 text-danger">
          We found a user associated with this email. If this is you, please{' '}
          <Link
            to={{
              pathname: '/auth/login',
              state: {
                nextPathname: window.location.pathname,
                nextSearch: window.location.search,
              },
            }}
          >
            log in
          </Link>{' '}
          to request an invitation.
        </p>
      ) : null}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmailCheckInputQuestion);
